
import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const Registration = () => {
    return (
        <>
            <div className="breadcrumb">
                <h2>Registration</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>Admission</li>
                    <li>|</li>
                    <li>Registration</li>
                </ul>
            </div>
            <div className="inner_page uniform_section">
                <div className="container">
                    <div className="row">
                         
                        <div className="col-md-8">
                            <p>All prospective candidates for any class must get their names registered at the school office. The dates of registration shall be intimated through the principal's circular. No registration shall be made prior to the dates specified.</p>
                        </div>
                        <div className="col-md-4">
                           <LazyLoad> <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/admission.jpg" alt="st francis school, Amritsar" className="img-fluid bordered_img" /></LazyLoad>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Registration
